/**
 * Route-chunk warmers for nav-intent prefetch. Each entry loads the same lazy
 * chunk that App.tsx's `lazyWithRetry` route mounts — identical dynamic-import
 * specifiers resolve to the same Rollup/Vite chunk, so calling one of these on
 * hover/pointerdown of a nav link populates the module cache the route reuses.
 *
 * Keep this a small, data-driven map keyed by the nav `to` path (query strings
 * are stripped by `warmRouteChunk`). Only routes reachable from the nav rails
 * need entries.
 */
const routeChunkLoaders: Record<string, () => Promise<unknown>> = {
  '/dashboard': () => import('@/pages/DashboardPage'),
  '/sites': () => import('@/pages/BoardPage'),
  '/search': () => import('@/pages/SearchPage'),
  '/review': () => import('@/pages/ReviewQueuePage'),
  '/sales': () => import('@/pages/SalesPage'),
  '/purchase-orders': () => import('@/pages/PurchaseOrdersPage'),
  '/vendors': () => import('@/pages/VendorsPage'),
  '/reports': () => import('@/pages/ReportsPage'),
  '/chat': () => import('@/pages/ChatPage'),
  '/safety': () => import('@/pages/SafetyPage'),
  '/my-documents': () => import('@/pages/MyDocumentsPage'),
  '/catalog': () => import('@/pages/CatalogPage'),
  '/admin': () => import('@/pages/AdminPage'),
  '/settings': () => import('@/pages/SettingsPage'),
};

/** Warm the chunk for a nav destination. Ignores the query string and unknown paths. */
export function warmRouteChunk(to: string): void {
  const path = to.split('?')[0];
  const loader = routeChunkLoaders[path];
  if (loader) void loader().catch(() => {});
}
